import { styled } from '../jss-style';
import popoverStyle from './popover';

const usePopoverStyle = styled(popoverStyle, 'popover');
export { popoverStyle, usePopoverStyle };
export default usePopoverStyle;
